// Action Types for Cancellation Tracking
export const FETCH_CANCELLATIONS_REQUEST = "FETCH_CANCELLATIONS_REQUEST";
export const FETCH_CANCELLATIONS_SUCCESS = "FETCH_CANCELLATIONS_SUCCESS";
export const FETCH_CANCELLATIONS_FAILURE = "FETCH_CANCELLATIONS_FAILURE";

export const CREATE_CANCELLATION_INVOICE_REQUEST = "CREATE_CANCELLATION_INVOICE_REQUEST";
export const CREATE_CANCELLATION_INVOICE_SUCCESS = "CREATE_CANCELLATION_INVOICE_SUCCESS";
export const CREATE_CANCELLATION_INVOICE_FAILURE = "CREATE_CANCELLATION_INVOICE_FAILURE";

export const UPDATE_CANCELLATION_STATUS_REQUEST = "UPDATE_CANCELLATION_STATUS_REQUEST";
export const UPDATE_CANCELLATION_STATUS_SUCCESS = "UPDATE_CANCELLATION_STATUS_SUCCESS";
export const UPDATE_CANCELLATION_STATUS_FAILURE = "UPDATE_CANCELLATION_STATUS_FAILURE";

export const FETCH_CANCELLATION_STATISTICS_REQUEST = "FETCH_CANCELLATION_STATISTICS_REQUEST";
export const FETCH_CANCELLATION_STATISTICS_SUCCESS = "FETCH_CANCELLATION_STATISTICS_SUCCESS";
export const FETCH_CANCELLATION_STATISTICS_FAILURE = "FETCH_CANCELLATION_STATISTICS_FAILURE";
